import React, { useEffect, useState, useContext } from "react";
import { Collapse, DatePicker, Form, Select, Input, Button, Image } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Api from "../../../../services/ServiceApi";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import { setProblemDetailList } from "../../../../actions/fixProblemAction";
import { setFixProblemPic } from "../../../../actions/fixProblemPicAction";
import MapFixedProblem from "./fix_problem_map_detail";
import { handleForm } from "../../../../contexts";
import StatusInfoModal from "../../../utility/status_info_modal";
import { dynamicFunction } from "../../../../pages/uih/wf_controllers/BtnController/dynamicFunction";
import {
  CallActionBtn,
  dynamicExternalFunction,
} from "../../../../pages/uih/wf_controllers/BtnController/dynamicAction";
import {
  defaultFormItemLayout,
  tailLayout,
} from "../../../utility/form_layout";
import ApproveProcessModal from "../../../approve_process/approve_process_modal";
import ApproveProcessLog from "../../../approve_process/approve_process_log";
import { isMobile } from "react-device-detect";

const { Panel } = Collapse;
const { Option } = Select;
const { callExternalUrlApprove } = dynamicExternalFunction;

export default function Fix_Problem_Acceptance({
  CompanyId,
  OperatorId,
  ProjectId,
  jobData,
  headerdata,
  Workflowdata,
}) {
  const dispatch = useDispatch();
  const { form, showReject, setshowReject } = useContext(handleForm);
  const { fixProblemPic, fixProblemlist } = useSelector((state) => ({
    fixProblemPic: state.fixProblemPic.fixProblemPic,
    fixProblemlist: state.fixProblemlist.fixProblemDetailList,
  }));
  const [jobDetail] = jobData.result_job_detail ?? [null];
  const [jobAssetdetail] = jobData.result_assetdetail ?? [null];
  const [initForm, setinitForm] = useState({});
  const [formData, setformData] = useState({});
  const [currebtJobFixProblemId, setcurrebtJobFixProblemId] = useState(null);
  const [callApiFinish, setcallApiFinish] = useState(false);
  const [disableBtn, setdisableBtn] = useState(false);
  const [insertOrUpdate, setinsertOrUpdate] = useState(false);
  const [tempActionDetail, settempActionDetail] = useState({});
  const [currentAcceptanceID, setcurrentAcceptanceID] = useState(0);
  const [spin, setspin] = useState(true);
  const [loadingText, setloadingText] = useState("Loading Action");
  const [statusInfoModalMode, setstatusInfoModalMode] = useState("success");
  const [approveId, setapproveId] = useState(null);
  const [callGoApprove, setcallGoApprove] = useState(true);
  const [externalUrl, setexternalUrl] = useState(null);
  const callFunction = new dynamicFunction(
    CompanyId,
    OperatorId,
    ProjectId,
    headerdata,
    null,
    setdisableBtn,
    setloadingText,
    setspin,
    setstatusInfoModalMode,
    form
  );
  useEffect(() => {
    let onFetch = false;
    if (!onFetch) {
      Api.post("job_detail/get_jobfixproblem_list", {
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
        job_id: jobAssetdetail?.job_id,
      }).then((res) => {
        if (res.data.result?.code === "P") {
          dispatch(setProblemDetailList(res.data.data?.job_fixproblem_List));
          dispatch(setFixProblemPic(res.data.data?.result_oper_pic));
          if (res.data.data?.job_fixproblem_List.length > 0) {
            const firstRes = res.data.data.job_fixproblem_List[0];
            setcurrebtJobFixProblemId(firstRes.job_FixProblem_id);

            Api.post("job_detail/get_oper_job_fixproblem_acceptance_list", {
              company_id: CompanyId,
              operator_id: OperatorId,
              project_id: ProjectId,
              job_id: jobAssetdetail?.job_id,
              job_FixProblem_id: firstRes.job_FixProblem_id,
            }).then((res) => {
              const { result, data } = res.data;
              if (result.code === "P") {
                if (data !== undefined && data.length > 0) {
                  setinsertOrUpdate(true);
                  const acceptanceData = res.data.data[0];
                  setcurrentAcceptanceID(
                    acceptanceData.fixproblem_acceptance_id
                  );
                  setapproveId(acceptanceData?.approve_id);
                  setexternalUrl(JSON.parse(acceptanceData?.external_url));
                  // console.log(JSON.parse(acceptanceData?.external_url));
                  setinitForm({
                    jobInServiceTime: moment(acceptanceData.in_service_time),
                    maintainType: acceptanceData.maintain_type_id,
                    ownerNetwork: acceptanceData.owner_network_id,
                    jobSLA: acceptanceData.slA_Id,
                    jobCause: acceptanceData.cause_Id,
                    jobSubCause: acceptanceData.subCause_Id,
                    action: acceptanceData.action_Id,
                    problemDetail: firstRes.fixProblem_detail ?? null,
                    actionDetail: firstRes?.cause_Probdetail_Fix_Name ?? null,
                    approveDetail: acceptanceData.accept_detail,
                    last_approve_level_seq:
                      acceptanceData.last_approve_level_seq,
                    job_id: acceptanceData.job_id,
                    approve_id: acceptanceData.approve_id ?? null,
                    approve_status_id: acceptanceData?.approve_status_id,
                    exclusion_detail: firstRes.exclusion_detail,
                  });
                  settempActionDetail({
                    problemDetail: firstRes.fixProblem_detail,
                    actionDetail: firstRes.action_detail,
                  });
                  fetchMasterData(
                    acceptanceData.owner_network_id,
                    acceptanceData.cause_Id
                  );
                  setcallApiFinish(true);
                } else {
                  setinsertOrUpdate(false);
                  setcallApiFinish(true);
                  setinitForm({
                    maintainType: firstRes.maintain_type_id,
                    ownerNetwork: firstRes.owner_network_id,
                    jobSLA: firstRes.slA_Id,
                    jobCause: firstRes.cause_Id,
                    jobSubCause: firstRes.subCause_Id,
                    action: firstRes.action_Id,
                    problemDetail: firstRes.fixProblem_detail,
                    actionDetail: firstRes.cause_Probdetail_Fix_Name,
                  });
                  settempActionDetail({
                    problemDetail: firstRes.fixProblem_detail,
                    actionDetail: firstRes.cause_Probdetail_Fix_Name,
                  });
                  fetchMasterData(firstRes.owner_network_id, firstRes.cause_Id);
                }
              }
            });
          } else {
            setinsertOrUpdate(false);
            setcallApiFinish(true);
            fetchMasterData(null, null);
          }
        } else {
          setcallApiFinish(true);
          fetchMasterData(null, null);
          setinsertOrUpdate(false);
        }
      });
    }
    return () => {
      onFetch = true;
    };
  }, []);
  function fetchMasterData(ownerNetwork = null, causeid = null) {
    axios
      .all([
        Api.post("master_data/job_sla_type", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_type_id: 0,
        }),
        Api.post("master_data/job_cause", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          owner_network_id: ownerNetwork,
        }),
        Api.post("master_data/job_action_type", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_type_id: headerdata.job_type_id,
        }),
        Api.post("master_data/owner_network_single", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
        }),
        Api.post("master_data/maintain_type_single", {
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
        }),
      ])
      .then(
        ([
          resJobSLA,
          resJobCause,
          resActionType,
          resOwnerNetwork,
          resMaintain,
        ]) => {
          const { data: resultJobSLA } = resJobSLA;
          const { data: resultJobCause } = resJobCause;
          const { data: resultActionType } = resActionType;
          const { data: resultOwnerNetwork } = resOwnerNetwork;
          const { data: resultMainTain } = resMaintain;
          const jobSLAList = resultJobSLA?.data.result.map((s) => ({
            ...s,
            value: s.sla_id,
            label: s.sla_name,
          }));
          const jobCauseList = resultJobCause?.data.result.map((s) => ({
            ...s,
            value: s.cause_id,
            label: s.cause_name,
          }));
          const actionTypeList = resultActionType?.data.result.map((s) => ({
            ...s,
            value: s.cause_Probdetail_Fix_ID,
            label: s.cause_Probdetail_Fix_Name,
          }));
          const OwnerNetwork = resultOwnerNetwork?.data.result.map((m) => ({
            value: m.owner_network_id,
            label: m.owner_network_name,
          }));
          const MainTain = resultMainTain?.data.result.map((s) => ({
            value: s.maintain_type_id,
            label: s.maintain_name,
          }));
          if (causeid !== null) {
            Api.post("master_data/job_sub_cause", {
              company_id: CompanyId,
              operator_id: OperatorId,
              project_id: ProjectId,
              cause_id: causeid,
            })
              .then(({ data: res }) => {
                const { result, data } = res;

                if (result.code === "P" || result.value === "P") {
                  const jobSubCausesList = data?.result.map((s) => ({
                    ...s,
                    value: s.sub_cause_id,
                    label: `${s.subCause_Desc1} : ${s.subCause_Desc2}`,
                  }));
                  setformData((form) => ({
                    ...form,
                    slaList: jobSLAList,
                    jobCauses: jobCauseList,
                    actions: actionTypeList,
                    jobSubCauses: jobSubCausesList,
                    OwnerNetwork: OwnerNetwork,
                    MainTain: MainTain,
                  }));
                  setcallApiFinish(true);
                }
              })
              .catch((err) => console.log(err));
          } else {
            setformData({
              ...formData,
              slaList: jobSLAList,
              jobCauses: jobCauseList,
              actions: actionTypeList,
              OwnerNetwork: OwnerNetwork,
              MainTain: MainTain,
            });
            setcallApiFinish(true);
          }
        }
      )
      .catch((err) => console.log(err));
  }
  const copyDetail = () => {
    setdisableBtn(true);
    let formValue = form.getFieldsValue(true);
    form.setFieldsValue({
      approveDetail: `${formValue.problemDetail} ${formValue.actionDetail}`,
    });

    setdisableBtn(false);
  };
  const handleChangeJobCause = (value) => {
    Api.post("master_data/job_sub_cause", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      cause_id: value,
    })
      .then(({ data: res }) => {
        const { result, data } = res;

        if (result.code === "P" || result.value === "P") {
          const jobSubCausesList = data?.result.map((s) => ({
            ...s,
            value: s.sub_cause_id,
            label: `${s.subCause_Desc1} : ${s.subCause_Desc2}`,
          }));

          form.setFieldsValue({ jobSubCause: null });

          setformData({
            ...formData,
            jobSubCauses: jobSubCausesList,
          });
        }
      })
      .catch((err) => console.log(err));
  };
  const handleOwnerNetworkChange = (value) => {
    Api.post("master_data/job_cause", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      owner_network_id: value,
    }).then((res) => {
      const { result, data } = res.data;
      if (result.code === "P") {
        const jobCauseList = data?.result.map((s) => ({
          ...s,
          value: s.cause_id,
          label: s.cause_name,
        }));
        form.setFieldsValue({ jobCause: null });
        setformData({
          ...formData,
          jobCauses: jobCauseList,
        });
      }
    });
  };

  const onSubmit = (values) => {
    setdisableBtn(true);
    setloadingText("Loading Action");
    const sendBtn = Workflowdata?.filter(
      (s) => s.next_main_action_id === 43
    )[0];

    console.log("sendBtn", sendBtn);
    if (insertOrUpdate) {
      Api.post("job_detail/update_oper_job_fixproblem_acceptance", {
        fixproblem_acceptance_id: currentAcceptanceID,
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
        job_FixProblem_id: currebtJobFixProblemId ?? 0,
        job_progress_id: jobAssetdetail?.job_progress_id,
        job_id: jobAssetdetail?.job_id,
        SLA_Id: jobDetail.job_sla_id,
        Cause_Id: values.jobCause,
        SubCause_Id: values.jobSubCause,
        Action_Id: initForm.action ?? null,
        FixProblem_detail: values.problemDetail,
        in_service_time: moment(values.jobInServiceTime).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        maintain_type_id: values.maintainType,
        owner_network_id: values.ownerNetwork,
        Action_detail: values.actionDetail,
        Accept_detail: values.approveDetail,
        create_by: Cookies.get("userId"),
        form_id: fixProblemlist[0]?.form_id ?? null,
        problem_type_id: fixProblemlist[0]?.problem_type_id ?? null,
        service_cause_id: fixProblemlist[0]?.service_cause_id ?? null,
        service_type_id: fixProblemlist[0]?.service_type_id ?? null,
        ...sendBtn,
      })
        .then((res) => {
          const { result } = res.data;
          if (result.code === "P") {
            if (callGoApprove) {
              const { approve_id, last_approve_level_seq, job_id } = initForm;
              goApprove(
                approve_id,
                last_approve_level_seq,
                1,
                null,
                null,
                job_id,
                "acceptance",
                { ...sendBtn, action_data_dynamic: undefined }
              )
                .then((resA) => {
                  console.log("resA", resA);
                  if (resA) {
                    setloadingText("Success");
                    setspin(false);
                    // if (externalUrl.external_url?.length > 0) {
                    //   setloadingText("Loading External URL");
                    //   callExternalUrlApprove(
                    //     externalUrl.external_url[0]?.api_url,
                    //     job_id,
                    //     approve_id
                    //   ).then((resExternal) => {
                    //     const { Result } = resExternal?.data;
                    //     if (Result.Code === "P") {
                    //       setloadingText("Success");
                    //       setspin(false);
                    //     } else {
                    //       setloadingText(
                    //         "Success Action || Call External URL Fail" +
                    //           Result.ShowText
                    //       );
                    //       setspin(false);
                    //       setstatusInfoModalMode("error");
                    //     }
                    //   });
                    // } else {
                    //   setloadingText("Success");
                    //   setspin(false);
                    // }
                    // Api.post("Approve/get_approve_process", {
                    //   approve_id: approve_id,
                    // }).then((resD) => {
                    //   const { data } = resD.data;
                    //   const approve_status_id =
                    //     data?.approve_Process[0]?.approve_status_id;
                    //   if (approve_status_id === 1) {
                    //     callFunction
                    //       .goNextAndReload(sendBtn)
                    //       .then((resGonext) => {
                    //         console.log("debug", resGonext);
                    //         if (resGonext.success) {
                    //           if (externalUrl.external_url?.length > 0) {
                    //             setloadingText("Loading External URL");
                    //             callExternalUrlApprove(
                    //               externalUrl.external_url[0]?.api_url,
                    //               job_id,
                    //               approve_id
                    //             ).then((resExternal) => {
                    //               const { Result } = resExternal?.data;
                    //               if (Result.Code === "P") {
                    //                 setloadingText("Success");
                    //                 setspin(false);
                    //               } else {
                    //                 setloadingText(
                    //                   "Success Action || Call External URL Fail" +
                    //                     Result.ShowText
                    //                 );
                    //                 setspin(false);
                    //                 setstatusInfoModalMode("error");
                    //               }
                    //             });
                    //           } else {
                    //             setloadingText("Success");
                    //             setspin(false);
                    //           }
                    //         } else {
                    //           setloadingText(`Error : GoNext Fail`);
                    //           setspin(false);
                    //           setstatusInfoModalMode("error");
                    //         }
                    //       })
                    //       .catch((err) => {
                    //         setloadingText(`Error : ${err.err}`);
                    //         setspin(false);
                    //         setstatusInfoModalMode("error");
                    //       });
                    //   } else {
                    //     setloadingText("Success");
                    //     setspin(false);
                    //   }
                    // });
                  }
                })
                .catch((err) => {
                  setloadingText(`Error : ${err.msg}`);
                  setspin(false);
                  setstatusInfoModalMode("error");
                });
            } else {
              callFunction
                .goNextAndReload(sendBtn)
                .then(() => {
                  if (
                    sendBtn.external_url_type &&
                    sendBtn.external_url_type === "json"
                  ) {
                    setloadingText("Loading External URL");
                    callFunction.CallExternalurl(
                      JSON.parse(sendBtn.external_url)
                    );
                  } else {
                    setloadingText("Success");
                    setspin(false);
                  }
                })
                .catch((err) => {
                  setloadingText(`Error : ${err.err}`);
                  setspin(false);
                  setstatusInfoModalMode("error");
                });
            }
          } else {
            setloadingText(`Error : ${result?.showText}`);
            setstatusInfoModalMode("error");
            setspin(false);
          }
        })
        .catch((err) => {
          setloadingText(`Error : ${err}`);
          setstatusInfoModalMode("error");
          setspin(false);
        });
    } else {
      Api.post("job_detail/insert_oper_job_fixproblem_acceptance", {
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
        job_FixProblem_id: currebtJobFixProblemId ?? 0,
        job_progress_id: jobAssetdetail?.job_progress_id,
        job_id: jobAssetdetail?.job_id,
        SLA_Id: jobDetail.job_sla_id,
        Cause_Id: values.jobCause,
        SubCause_Id: values.jobSubCause,
        Action_Id: initForm.action ?? null,
        FixProblem_detail: values.problemDetail,
        in_service_time: moment(values.jobInServiceTime).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        maintain_type_id: values.maintainType,
        owner_network_id: values.ownerNetwork,
        Action_detail: values.actionDetail,
        Accept_detail: values.approveDetail,
        create_by: Cookies.get("userId"),
        form_id: fixProblemlist[0]?.form_id ?? null,
        problem_type_id: fixProblemlist[0]?.problem_type_id ?? null,
        service_cause_id: fixProblemlist[0]?.service_cause_id ?? null,
        service_type_id: fixProblemlist[0]?.service_type_id ?? null,
        ...sendBtn,
      })
        .then((res) => {
          const { result } = res.data;
          const sendBtn = Workflowdata?.filter(
            (s) => s.next_main_action_id === 43
          )[0];
          if (result.code === "P") {
            const { approve_id, last_approve_level_seq, job_id } = initForm;
            if (callGoApprove) {
              goApprove(
                approve_id,
                last_approve_level_seq,
                1,
                "Auto Approve",
                "Auto Approve",
                job_id,
                "acceptance"
              )
                .then((resA) => {
                  if (resA) {
                    Api.post("Approve/get_approve_process", {
                      approve_id: approve_id,
                    }).then((resD) => {
                      const { data } = resD.data;
                      const approve_status_id =
                        data?.approve_Process[0]?.approve_status_id;
                      if (approve_status_id === 1) {
                        callFunction
                          .goNextAndReload(sendBtn)
                          .then((resGonext) => {
                            console.log("debug", resGonext);
                            if (resGonext.success) {
                              if (externalUrl.external_url?.length > 0) {
                                setloadingText("Loading External URL");
                                callExternalUrlApprove(
                                  externalUrl.external_url[0]?.api_url,
                                  job_id,
                                  approve_id
                                ).then((resExternal) => {
                                  const { Result } = resExternal?.data;
                                  if (Result.Code === "P") {
                                    setloadingText("Success");
                                    setspin(false);
                                  } else {
                                    setloadingText(
                                      "Success Action || Call External URL Fail " +
                                        Result.ShowText
                                    );
                                    setspin(false);
                                    setstatusInfoModalMode("error");
                                  }
                                });
                              } else {
                                setloadingText("Success");
                                setspin(false);
                              }
                            } else {
                              setloadingText(`Error : GoNext Fail`);
                              setspin(false);
                              setstatusInfoModalMode("error");
                            }
                          })
                          .catch((err) => {
                            setloadingText(`Error : ${err.err}`);
                            setspin(false);
                            setstatusInfoModalMode("error");
                          });
                      } else {
                        setloadingText("Success");
                        setspin(false);
                      }
                    });
                  }
                })
                .catch((err) => {
                  setloadingText(`Error : ${err}`);
                  setspin(false);
                  setstatusInfoModalMode("error");
                });
            } else {
              callFunction
                .goNextAndReload(sendBtn)
                .then(() => {
                  if (
                    sendBtn.external_url_type &&
                    sendBtn.external_url_type === "json"
                  ) {
                    setloadingText("Loading External URL");
                    callFunction.CallExternalurl(
                      JSON.parse(sendBtn.external_url)
                    );
                  } else {
                    setloadingText("Success");
                    setspin(false);
                  }
                })
                .catch((err) => {
                  setloadingText(`Error : ${err.err}`);
                  setspin(false);
                  setstatusInfoModalMode("error");
                });
              setcurrentAcceptanceID(res.data.data[0].fixproblem_acceptance_id);
            }
          } else {
            setloadingText(`Error : ${result?.showText}`);
            setstatusInfoModalMode("error");
            setspin(false);
          }
        })
        .catch((err) => {
          setloadingText(`Error : ${err}`);
          setstatusInfoModalMode("error");
          setspin(false);
        });
    }
  };
  const goApprove = (
    approve_id,
    last_approve_level_seq,
    type,
    reason,
    remark,
    job_id,
    mode,
    workFlow
  ) => {
    return new Promise((resolve, reject) => {
      CallActionBtn["callApproveProcess"](
        approve_id ?? null,
        last_approve_level_seq,
        type,
        reason,
        remark,
        job_id,
        mode,
        null,
        workFlow
      )
        .then((res) => {
          if (res.success) {
            resolve(true);
          } else {
            reject(res);
          }
        })
        .catch((err) => reject(err));
    });
  };
  const statusInfoModalCallback = () => {
    setdisableBtn(false);
    window.location.reload();
  };
  const rejectCallBack = () => {
    setshowReject(false);
    window.location.reload();
  };

  return (
    <>
      {callApiFinish ? (
        <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
          <Panel
            header={
              <>
                <h4>{"บันทึกตรวจรับงาน"}</h4>
              </>
            }
            key="1"
          >
            <div className="d-flex align-content-md-start flex-wrap w-100">
              <div className="col col-12">
                <Form
                  form={form}
                  name="fix_problem_acceptance"
                  {...defaultFormItemLayout}
                  onFinish={onSubmit}
                  initialValues={{
                    problemDetail: initForm.problemDetail,
                    actionDetail: initForm.actionDetail,
                    exclusion_detail: initForm.exclusion_detail,
                  }}
                  id="fix_problem_acceptance_form"
                >
                  <Form.Item
                    name="jobInServiceTime"
                    label="In Service Time"
                    rules={[{ required: true, message: "กรุณาระบุเวลา" }]}
                  >
                    <DatePicker
                      showTime
                      placeholder="Select date/time"
                      format="YYYY-MM-DD HH:mm"
                    />
                  </Form.Item>
                  <Form.Item
                    name="maintainType"
                    label="ประเภทงานซ่อม"
                    rules={[
                      { required: true, message: "กรุณาเลือกประเภทงานซ่อม" },
                    ]}
                  >
                    <Select placeholder="Select">
                      {formData.MainTain?.map((d, i) => (
                        <Option
                          key={`acceptance_maintain_type_index_${i}`}
                          value={d.value}
                        >
                          <span className="default-thai-font">{d.label}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="ownerNetwork"
                    label="Owner Network"
                    rules={[
                      { required: true, message: "กรุณาเลือก Owner Network" },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      onChange={handleOwnerNetworkChange}
                    >
                      {formData.OwnerNetwork?.map((d, i) => (
                        <Option
                          key={`acceptance_onwer_network_index_${i}`}
                          value={d.value}
                        >
                          <span className="default-thai-font">{d.label}</span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="jobCause"
                    label="Group Cause"
                    rules={[
                      { required: true, message: "กรุณาเลือก Group Cause" },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      onChange={handleChangeJobCause}
                    >
                      {formData.jobCauses?.map((data, index) => (
                        <Option
                          key={`progress_detail_form_progress_${index + 1}`}
                          value={data.value}
                        >
                          <span className="default-thai-font">
                            {data.label}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="jobSubCause"
                    label="Sub Cause"
                    rules={[
                      { required: true, message: "กรุณาเลือก Sub Cause" },
                    ]}
                  >
                    <Select placeholder="Select">
                      {formData.jobSubCauses?.map((data, index) => (
                        <Option
                          key={`progress_detail_form_progress_${index + 1}`}
                          value={data.value}
                        >
                          <span className="default-thai-font">
                            {data.label}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="problemDetail"
                    label="รายละเอียดสำหรับ UIH"
                    rules={[
                      { required: true, message: "กรุณาระบุรายละเอียดงาน" },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue("actionDetail") !== value
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            "รายละเอียดสำหรับ UIH ต้องไม่ซ้ำกับ รายละเอียดการแก้ไข"
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.TextArea rows="5"></Input.TextArea>
                  </Form.Item>
                  <Form.Item
                    name="actionDetail"
                    label="รายละเอียดการแก้ไข"
                    rules={[
                      {
                        required: true,
                        message: "กรุณาระบุรายละเอียดการแก้ไข",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (
                            !value ||
                            getFieldValue("problemDetail") !== value
                          ) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            "รายละเอียดการแก้ไข ต้องไม่ซ้ำกับ รายละเอียดสำหรับ UIH "
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.TextArea rows="2"></Input.TextArea>
                  </Form.Item>
                  <div className="mt-1 mb-1" style={{ marginLeft: "25%" }}>
                    <Button
                      type="primary"
                      onClick={copyDetail}
                      disabled={disableBtn}
                    >
                      Copy to รายละเอียดสำหรับลูกค้า
                    </Button>
                  </div>
                  <Form.Item
                    name="approveDetail"
                    label="รายละเอียดสำหรับลูกค้า"
                    rules={[
                      {
                        required: true,
                        message: "กรุณาระบุรายละเอียดสำหรับลูกค้า",
                      },
                    ]}
                  >
                    <Input.TextArea rows="5"></Input.TextArea>
                  </Form.Item>
                  <Form.Item name="exclusion_detail" label="สาเหตุล่าช้า">
                    <Input.TextArea rows="2" disabled></Input.TextArea>
                  </Form.Item>
                  <Form.Item name="maintainDetail" label="รายละเอียดการซ่อม">
                    <MapFixedProblem
                      CompanyId={CompanyId}
                      OperatorId={OperatorId}
                      ProjectId={ProjectId}
                      headerdata={headerdata}
                      showHeader={false}
                    ></MapFixedProblem>
                  </Form.Item>
                  <Form.Item name="fixProblemPhoto" label="ภาพประกอบการปิดงาน">
                    <span className="col-12 col-sm-8 content-text">
                      <div className="mr-4" style={{ cursor: "pointer" }}>
                        <Image.PreviewGroup>
                          {fixProblemPic
                            .filter(
                              (s) =>
                                s.reference_id === currebtJobFixProblemId &&
                                s.pic_type === "F"
                            )
                            .map((m, i) => (
                              <Image
                                key={`operjob_pic_acceptance${i}`}
                                width={150}
                                height={80}
                                src={Api.checkPath(
                                  m.pic_url_path,
                                  m.pic_upload_name
                                )}
                              ></Image>
                            ))}
                        </Image.PreviewGroup>
                      </div>
                    </span>
                  </Form.Item>
                  {/* <Form.Item {...tailLayout}> */}
                  <div className="col-lg-12 col-sm-8 content-text text-center">
                    <Renderbtn
                      renderBtn={{
                        visible: true,
                        html_tag: "button",
                        type: "Text",
                        text: `Clear`,
                        css: `btn btn-sm btn-light ${
                          isMobile ? "col-sm-4" : ""
                        }`,
                      }}
                      btnMiddleware={() => {
                        form.resetFields();
                      }}
                      index="view_btn_closemodal"
                      item={null}
                      disable={false}
                    ></Renderbtn>
                    <Renderbtn
                      renderBtn={{
                        visible: true,
                        html_tag: "button",
                        type: "ImagewithText",
                        text: `ส่งกลับแก้ไข`,
                        icon_align: "left",
                        image_path: "/icon/bbtec/button/md/reject.svg",
                        css: `btn btn-sm btn-danger ${
                          isMobile ? "col-sm-4" : ""
                        }`,
                      }}
                      btnMiddleware={() => setshowReject(true)}
                      index="view_submit_form"
                      item={null}
                      disable={false}
                    ></Renderbtn>
                    <Renderbtn
                      renderBtn={{
                        visible: true,
                        html_tag: "button",
                        type: "ImagewithText",
                        text: `ตรวจรับงานเรียบร้อย`,
                        icon_align: "left",
                        image_path: "/icon/bbtec/button/md/approve.svg",
                        css: `btn btn-sm btn-success ${
                          isMobile ? "col-sm-4" : ""
                        }`,
                      }}
                      btnMiddleware={() => form.submit()}
                      index="view_submit_form"
                      item={null}
                      disable={false}
                    ></Renderbtn>
                  </div>
                  {/* </Form.Item> */}
                </Form>
                {approveId ? (
                  <div className="col col-12 mt-3">
                    <div className="row">
                      <ApproveProcessLog
                        header="UIH ตรวจรับงาน"
                        sendData={{ approve_id: approveId }}
                      ></ApproveProcessLog>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </Panel>
        </Collapse>
      ) : (
        <div
          style={{
            width: "96%",
            marginLeft: "2%",
            marginTop: "1%",
            height: "400px",
          }}
        >
          <Skeleton count={1} height={400} />
        </div>
      )}
      <StatusInfoModal
        visible={disableBtn}
        showSpinIcon={spin}
        statusText={loadingText}
        mode={statusInfoModalMode}
        callbackFunction={statusInfoModalCallback}
      ></StatusInfoModal>
      {showReject ? (
        <ApproveProcessModal
          visible={showReject}
          callbackFunction={rejectCallBack}
          sendData={{
            approve_id: approveId,
            approve_status_id: initForm?.approve_status_id,
            mode: "rejectAcceptance",
            detail: {
              wf: Workflowdata?.filter((s) => s.next_main_action_id === 45)[0],
              operator_id: OperatorId,
              project_id: ProjectId,
              job_id: jobDetail?.job_id,
              job_progress_id: jobAssetdetail?.job_progress_id,
              job_type_id: jobDetail?.job_type_id,
            },
          }} //test
          defaultApprove={2}
          disableRadio={true}
        ></ApproveProcessModal>
      ) : null}
    </>
  );
}
